<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="fl-right">
        <button
          type="button"
          pButton
          (click)="exporttocsv()"
          class="ui-button-success csv-export">
          <i class="mdl2-excel"></i> Export to CSV
          @if (excelLoading) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
        &nbsp;
        <button
          type="button"
          pButton
          (click)="exporttompr()"
          class="ui-button-success csv-export">
          Export to MPR
          @if (excelLoading) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #allprofilesData
          [columns]="profilecols"
          [value]="allprofilesList"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          [lazy]="true"
          (onLazyLoad)="loadSearchContent($any($event))"
          scrollHeight="500px"
          [paginator]="true"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          (onPage)="pageChange()"
          [totalRecords]="totalRecords"
          exportFilename="M365EventRecords"
          [rows]="dataViewRecsPerPage">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <div class="search-box-container">
                <div class="search-box mr-2">
                  <input
                    type="text"
                    pInputText
                    size="30"
                    placeholder="Search"
                    (input)="searchOrFilterprofiles()"
                    style="width: auto"
                    [(ngModel)]="searchAndFilterInput.searchString"
                    style="width: 340px" />
                </div>
                <i class="fa fa-search ml-2"></i>
                <span class="pageInfo visiblelg resettble"
                  >- {{ currentPageInfo }}</span
                >
              </div>
              <span style="float: right; position: relative; bottom: 32px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr>
              <th class="colsmall">
                <p-sortIcon [field]="'partnerId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'partnerId'" class="colsmall">
                MPNID/PartnerId<p-sortIcon [field]="'partnerId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'payeeEmail'" class="colsmall">
                Payee Email<p-sortIcon [field]="'payeeEmail'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'profileStatusName'" class="colsmall">
                Profile Status<p-sortIcon
                  [field]="'profileStatusName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'requestorEmail'" class="colsmall">
                Requestor Email<p-sortIcon
                  [field]="'requestorEmail'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'reqeustDate'" class="colsmall">
                Request Date<p-sortIcon [field]="'reqeustDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'programName'" class="colsmall">
                Programe<p-sortIcon [field]="'programName'"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th></th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterprofiles()"
                  [(ngModel)]="searchAndFilterInput.partnerInputMPNId" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterprofiles()"
                  [(ngModel)]="searchAndFilterInput.inputPayeeEmail" />
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="profileStatusDrpdwn"
                  appendTo="body"
                  placeholder="Profile Status"
                  [(ngModel)]="searchAndFilterInput.inputProfileStatuses"
                  (onChange)="searchOrFilterprofiles()"></p-multiSelect>
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterprofiles()"
                  [(ngModel)]="searchAndFilterInput.inputRequestorEmail" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterprofiles()"
                  [(ngModel)]="searchAndFilterInput.requestDate" />
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="programtypes"
                  #tak
                  appendTo="body"
                  placeholder="Programe"
                  [(ngModel)]="searchAndFilterInput.inputProgramTypes"
                  (onChange)="searchOrFilterprofiles()"></p-multiSelect>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              <td class="colsmall">
                <a
                  (click)="OpenUpdateDialog(rowData)"
                  (keydown.enter)="OpenUpdateDialog(rowData)"
                  tabindex="0">
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </a>
              </td>
              <td class="colsmall">{{ rowData.partnerId }}</td>
              <td class="colsmall">{{ rowData.payeeEmail }}</td>
              <td class="colsmall">{{ rowData.profileStatusName }}</td>
              <td class="colsmall">{{ rowData.requestorEmail }}</td>
              <td class="colsmall">{{ rowData.reqeustDate }}</td>
              <td class="colsmall">{{ rowData.programName }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Update Payment Profile Status"
  [(visible)]="displayUpdateBox"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [maximizable]="false"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false">
  <div class="dialog-body">
    <label for="profileStatusDropdown">Profile Status</label>
    @if (profileStatusDrpdwn.length) {
      <p-select
        appendTo="body"
        id="profileStatusDropdown"
        [options]="profileStatusDrpdwn"
        [(ngModel)]="selectedStatus"
        placeholder="Select Status"
        optionLabel="label"></p-select>
    }
  </div>
  <div class="footer">
    <button
      type="button"
      pButton
      (click)="updateProfileStatus()"
      class="flat btnmr ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
      Update
    </button>
    &nbsp;&nbsp;
    <button
      type="button"
      pButton
      (click)="displayUpdateBox = false"
      class="ui-button-secondary flat ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
      Cancel
    </button>
  </div>
</p-dialog>
